export const OfficeAccessoriesSearchLiveState = {
	url: '/accessories/search',
	title: 'Office Accessories Search Live',
	template: '<office-accessories-search-live></office-accessories-search-live>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeAccessoriesLiveSearchPageMod" */
			'@Containers/office-accessories-page/search-live/office-accessories-search-live.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
